import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoute, StaticRoutes } from '@news-mono/web-common'
import { layout } from '../../App.routing'

const createNewsletterSubscriptionPage: StaticRoute<TheWestSection> = () => {
    return {
        kind: 'page',
        heading: 'Newsletter Subscription',
        hideHeading: true,
        pageType: 'static',
        adTargeting: {
            pageId: 'newsletter-subscription',
            adUnitPath: '',
            ssAdUnits: [],
            topics: [],
        },
        section: 'default',
        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    verticalGutters: true,
                    horizontalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'thor',
                            props: {
                                containerWidth: '100%',
                                horizontalGutters: true,
                                hasBackgroundFill: true,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'newsletter-subscription',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}

export const getNewsletterSubscriptionRouteInfo: StaticRoutes<TheWestSection> =
    {
        '/newslettersubscribe': createNewsletterSubscriptionPage,
    }
